import React from 'react';
import { ChildrenInterface } from 'types';
import { generateContext } from './generateContext';

export function createStoreProvider<T>(useHook: () => T) {
  const [useContextConsumer, ContextProvider] = generateContext<T>();

  const StoreProvider: React.FC<ChildrenInterface> = ({ children }) => {
    const state = useHook();

    return (
      <ContextProvider value={state}>
        {children}
      </ContextProvider>
    );
  };

  return [useContextConsumer, StoreProvider] as const;
}
